import gazetteer from '@bridebook/toolbox/src/gazetteer';

/**
 * Whether a wedding location is a whole country, not a place in it. Signup sets the market's
 * country name, so a couple who never said where has that on file. Read as a place, it would
 * make a country-wide search look local. The app's redux selector wraps this.
 */
export const isGenericWeddingLocation = (
  location: { name?: string | null } | null | undefined,
): boolean => {
  const name = location?.name?.trim().toLocaleLowerCase();
  if (!name) {
    return false;
  }
  return gazetteer
    .getMarkets()
    .some((market) => market.getCountryName().toLocaleLowerCase() === name);
};
